function ReportsPage() {
    return <div>This is the Reports content</div>
  }

export default ReportsPage